<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h1>Übersichtliche Grafiken</h1>
                <p class="h2">Und wenn die Nutzenden konsequent sind, sehen sie die ersten Ergebnisse</p>
            </div>
            <div class="right-wrapper">
                <h2>Wie kann so ein Ergebnis aussehen?</h2>
                <p class="text">Nach 3 Monaten verlieren die Patientinnen und Patienten in der Regel 3 kg (2,8 % ihres Gewichts).</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" weiterBtn :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 21
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>

